import * as React from 'react';
import type { CategoryStyle, EmptyStateCopy, EmptyStateCta } from '../types';

type EmptyStateProps = {
  copy: EmptyStateCopy;
  cta: EmptyStateCta;
  badge: CategoryStyle;
};

export function EmptyState({ copy, cta, badge }: EmptyStateProps) {
  return (
    <div className="activity-dashboard__empty">
      <span className={`activity-item__icon activity-item__icon--${badge.tone} activity-dashboard__empty-icon`} aria-hidden="true">
        <i className={`fas ${badge.icon}`} />
      </span>
      <h3>{copy.title}</h3>
      <p className="text-muted mb-3">{copy.body}</p>
      <a className="btn btn-primary activity-dashboard__empty-cta" href={cta.href}>
        {cta.label}
      </a>
    </div>
  );
}
